import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import _kebabCase from "lodash/kebabCase";
var _excluded = ["ariaLevel", "children", "childrenInline", "className", "richText", "parseHTML", "textElement", "typog", "variant"],
  _excluded2 = ["href", "target", "style"];
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { useContext } from 'react';
import classnames from 'classnames';
import parse, { domToReact } from 'html-react-parser';
import { RichTextJSON } from "../RichTextJSON/RichTextJSON";
import { Link } from "../../Button/Link/Link";
import { ThemeContext, defaultThemeContext } from "../../../context/theme.context";
import Utility from "../../Utility/Utility";
import "../../../styles/fonts.scss";
import styles from "./Text.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var textTypogs = ['mastheadHeadline', 'headline1Xl', 'headline1', 'headline2', 'headline3', 'headline4', 'headline5', 'headline6', 'headline7', 'headline8', 'subhead1', 'subhead2', 'subhead3', 'subhead4', 'subhead5', 'subhead6', 'eyebrow1', 'eyebrow2', 'eyebrow3', 'eyebrow4', 'bodycopyExtraSmall', 'bodycopySmall', 'bodycopy', 'bodycopyLarge', 'bodycopyExtraLarge', 'caption', 'captionSmall'];
export var textVariants = ['default', 'accent', 'accent2', 'accent3'];
export var Text = function Text(_ref) {
  var ariaLevel = _ref.ariaLevel,
    children = _ref.children,
    _ref$childrenInline = _ref.childrenInline,
    childrenInline = _ref$childrenInline === void 0 ? false : _ref$childrenInline,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$richText = _ref.richText,
    richText = _ref$richText === void 0 ? false : _ref$richText,
    _ref$parseHTML = _ref.parseHTML,
    parseHTML = _ref$parseHTML === void 0 ? true : _ref$parseHTML,
    _ref$textElement = _ref.textElement,
    textElement = _ref$textElement === void 0 ? 'div' : _ref$textElement,
    typog = _ref.typog,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'default' : _ref$variant,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var theme = useContext(ThemeContext);
  var Element = ariaLevel ? "h".concat(ariaLevel) : textElement || 'div';
  var childElement = childrenInline || ariaLevel || textElement === 'span' ? 'span' : 'div';

  // check for whether a node's descendants are table tags
  var isDescendantTableTag = function isDescendantTableTag(parent, node) {
    var descendants = {
      table: ['colgroup', 'thead', 'tbody'],
      colgroup: ['col'],
      thead: ['tr'],
      tbody: ['tr'],
      tr: ['th', 'td']
    };
    if (!parent.name || !node.name) {
      return false;
    }
    return (descendants[parent.name] || []).indexOf(node.name) >= 0;
  };

  // html-react-parser parse() options
  // replace <a> in richtext with <Link />
  var replaceOptions = {
    replace: function replace(domNode) {
      var _ref2 = domNode || {},
        name = _ref2.name,
        attribs = _ref2.attribs,
        children = _ref2.children,
        next = _ref2.next,
        parent = _ref2.parent,
        prev = _ref2.prev,
        type = _ref2.type;
      if (name === 'a') {
        var _ref3 = attribs,
          href = _ref3.href,
          target = _ref3.target,
          style = _ref3.style,
          _otherProps = _objectWithoutProperties(_ref3, _excluded2);
        var newWindow = target === '_blank' ? true : false;
        return /*#__PURE__*/_jsx(Link, _objectSpread(_objectSpread({
          url: href,
          newWindow: newWindow
        }, _otherProps), {}, {
          children: domToReact(children || [], replaceOptions)
        }));
      } else if (type === 'text' && parent) {
        // strip whitespace from table tag nodes
        if (next) {
          if (isDescendantTableTag(parent, next)) {
            return /*#__PURE__*/_jsx(_Fragment, {});
          }
        }
        if (prev) {
          if (isDescendantTableTag(parent, prev)) {
            return /*#__PURE__*/_jsx(_Fragment, {});
          }
        }
      }
    }
  };
  var renderedChildren = null;
  if (richText && typeof children === 'string' && RichTextJSON.parseJSON(children)) {
    renderedChildren = /*#__PURE__*/_jsx(RichTextJSON, {
      json: children
    });
  } else if (children) {
    // if richtext is enabled, run html-react-parser
    // in some cases, children is of type Array when parse()
    // expects a parameter of type string.
    var parsedRichText = richText && parseHTML;
    var parsedChildren = parsedRichText ? parse(children.toString(), replaceOptions) : children;
    renderedChildren = Utility.dangerousHTML(parsedChildren, childElement, parsedRichText);
  }
  return /*#__PURE__*/_jsx(Element, _objectSpread(_objectSpread({
    className: classnames(richText && styles['rich-text'], styles["typog-".concat(typog)], theme !== defaultThemeContext && "theme--".concat(_kebabCase(theme)), variant !== 'default' && "typog--".concat(variant), className)
  }, otherProps), {}, {
    children: renderedChildren
  }));
};